module.exports = __webpack_public_path__ + "img/msantos.6c2d5fe7.png";